import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
// components
import i18n from "../../../../i18n";
import { Helmet } from "react-helmet";
import LogActivity from "../../../../components/modules/log/activity";
import LogActivityMiddleware from "../../../../middleware/modules/log/activity";
// import CustomerApproval from "../../../../components/modules/log/customer-approval";
// middlewares
const mapStateToProps = ({ auth, logActivity }) => ({
  isProcessing: logActivity.isProcessing,
  isError: logActivity.isError,
  errorMessage: logActivity.errorMessage,
  data: logActivity.data,
  showModal:logActivity.showModal
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      search: (data) => LogActivityMiddleware.list(data),
      reset: () => LogActivityMiddleware.resetList(),
      ApproveData: (data,value,search) => LogActivityMiddleware.beforeApprove(data,value,search),
      RejectData: (data,value, search) => LogActivityMiddleware.beforeReject(data, value,search),
      view: data =>LogActivityMiddleware.getOne(data),
    },
    dispatch
  );
};
class LogActivityContainer extends Component {
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    errorMessage: PropTypes.any,
    datalist: PropTypes.any,
    search: PropTypes.func.isRequired,
  };

  static defaultProps = {
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isError: false,
    errorMessage: [],
  };

  constructor(props) {
    super(props);
    this.viewItem=this.viewItem.bind(this);
  }

  viewItem(id){
    this.props.view(id)
    // this.props.getHelper()
  }

  componentWillMount() {
    const search = {
      limit: 10,
    };
    this.props.reset();
    this.props.search(search);
  }
  render() {
    const {showModal} = this.props;
     return (
      <React.Fragment>
         <Helmet>
            <title>{i18n.t("Log Activity")}</title>
          </Helmet>
          <LogActivity
           {...this.props}
           showModal={showModal}
           viewItem={this.viewItem}
          
          />
      </React.Fragment>
      
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LogActivityContainer);
